/**
 * Kurzlink zur Buchungsmaske, z. B. für E-Mail-Signaturen:
 *   https://www.apartments-badreichenhall.de/?buchen
 * öffnet nach dem Laden die DIRS21-Buchungsmaske per dirs21.openOne().
 *
 * Das DIRS21-SDK wird async geladen (inc/dirs21.php, NEUMEIER_DIRS21_SDK_URL),
 * darum wird kurz gewartet, bis window.dirs21.openOne existiert.
 */

// max. Wartezeit auf das SDK in ms
const SDK_TIMEOUT = 15000;
const SDK_POLL = 200;

export function initBookingLink() {
    if (!new URLSearchParams(window.location.search).has("buchen")) {
        return;
    }

    const started = Date.now();
    const tryOpen = () => {
        if (window.dirs21 && typeof window.dirs21.openOne === "function") {
            window.dirs21.openOne();
        } else if (Date.now() - started < SDK_TIMEOUT) {
            setTimeout(tryOpen, SDK_POLL);
        }
    };
    tryOpen();
}
